export default __webpack_public_path__ + "static/media/web-icon.aa09f190.jpg";